import { createSelector } from 'reselect';
import { isNil, isNotNil } from '../../../util/object';
import { CREATIVE_MODES } from '../../../constants';

// TODO(lemieux) remove this state out of playback
const getCreativeMode = (state) => state.playback.creativeMode;

export const getCurrentRoute = (state) => {
  return state.route.route;
};

export const getCurrentRouteData = (state) => {
  return state.route.routeData;
};

export const inEditor = (state) => {
  const route = getCurrentRoute(state);
  return isNotNil(route) && route.isEditor;
};

export const inSimpleFlow = (state) => {
  const route = getCurrentRoute(state);
  if (isNil(route)) return false;

  const creativeMode = getCreativeMode(state);
  if (creativeMode === CREATIVE_MODES.SIMPLE) return true;
  return route.isSimpleFlow;
};

export const inEpisodeFlow = createSelector(
  [getCurrentRoute, getCreativeMode],
  (route, creativeMode) => {
    if (isNil(route)) return false;

    if (creativeMode === CREATIVE_MODES.SHOWS) return true;
    return route.isEpisodeFlow;
  },
);

// A single selector to group common functionality in the Simple and Episode Flow editors.
export const inSimpleEditor = (state) => {
  return inSimpleFlow(state) || inEpisodeFlow(state);
};

export const getCreativeModeForRoute = (state) => {
  if (inSimpleFlow(state)) return CREATIVE_MODES.SIMPLE;
  if (inEpisodeFlow(state)) return CREATIVE_MODES.SHOWS;

  return CREATIVE_MODES.ADVANCED;
};
